import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import type { OfferSelectOption } from '@core/offers-ui';
import type { SelectGroupedOptions } from '@core/user-interface-legacy';
import { AddEvaluationDropdownForm } from '@recruitee/evaluations-types';
import { EvaluationFormControlComponent } from '@recruitee/evaluations-ui';

import { EvaluationJobFieldComponent } from '../../../common/evaluation-job-field/evaluation-job-field.component';

@Component({
  selector: 'rt-add-evaluation-dropdown-form',
  templateUrl: './add-evaluation-dropdown-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ReactiveFormsModule, EvaluationJobFieldComponent, EvaluationFormControlComponent],
})
export class AddEvaluationDropdownFormComponent {
  public readonly form = input.required<AddEvaluationDropdownForm>();
  public readonly groupedTemplates = input<SelectGroupedOptions[]>([]);
  public readonly templatesLoaded = input<boolean>(true);
  public readonly offers = input<OfferSelectOption[]>([]);

  protected showJobControl = computed(() => this.offers().length > 1);
}
